// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SearchPage.module.css */
.SearchPage_searchPageContainer__L7f8g {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 12rem 0rem;
  
}

.SearchPage_searchWrapper__654NC {
  width: 100%;
  position: relative;
}

.SearchPage_searchContainer__C\\+ADr {
  width: 100%;
  position: relative;
  border-radius: 12px;
  overflow: visible;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
}

.SearchPage_searchContainer__C\\+ADr.SearchPage_focused__EJyn3 {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
}

.SearchPage_searchInputWrapper__GCIoN {
  display: flex;
  align-items: center;
  background-color: #DC2626;
  padding: 0.75rem 1rem;
  border-radius: 12px;
}

.SearchPage_searchIcon__1ZkpL {
  color: #fff;
  margin-right: 0.75rem;
}

.SearchPage_searchInput__uGKnk {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 1rem;
  background-color: transparent;
  color: #fff;
}
input::placeholder {
  color: #fff;
}

.SearchPage_clearButton__jToKa {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition-duration: 0.2s;
}

.SearchPage_clearButton__jToKa:hover {
  color: #000;
}

.SearchPage_loadingIcon__9njCf {
  color: #6b7280;
  margin-right: 0.75rem;
}

.SearchPage_spinning__tXvI9 {
  animation: SearchPage_spin__lbCzR 1s linear infinite;
}

@keyframes SearchPage_spin__lbCzR {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Suggestions */
.SearchPage_suggestionsContainer__J\\+E7o {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: #000;
  border-radius: 0 0 12px 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  z-index: 10;
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #000;
  border-top: none;
}

.SearchPage_suggestionsHeader__wy8jl,
.SearchPage_trendingHeader__ad-x6 {
  font-size: 0.875rem;
  font-weight: 600;
  color: #fff;
  margin: 0;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #fff;
}

.SearchPage_suggestionsList__xPJIs,
.SearchPage_trendingList__jtUli {
  list-style: none;
  padding: 0;
  margin: 0;
  color: #fff;
}

.SearchPage_suggestionItem__vqpwm,
.SearchPage_trendingItem__oKV8E {
  padding: 0.75rem 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background-color 0.2s;
}

.SearchPage_suggestionItem__vqpwm:hover,
.SearchPage_trendingItem__oKV8E:hover {
  background-color: #f9fafb;
  color: #000;
}

.SearchPage_contentTypeIcon__lPX5e {
  margin-right: 0.5rem;
  color: #6b7280;
}

/* Filters */
.SearchPage_filtersContainer__29DSu {
  display: flex;
  flex-wrap: wrap;
  margin: 1rem 0;
  gap: 0.5rem;
}

.SearchPage_filterButton__aFjrZ {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 100px;
  border: none;
  background-color: #000;
  font-size: 0.875rem;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  transition: all 0.2s;
}

.SearchPage_filterButton__aFjrZ:hover {
  background-color: rgba(255, 0, 0, 0.2);
}

.SearchPage_filterButton__aFjrZ.SearchPage_active__Et221 {
  background-color: red;
  color: #fff;
  border-color: red;
}

.SearchPage_filterButton__aFjrZ.SearchPage_active__Et221 .SearchPage_contentTypeIcon__lPX5e {
  color: #fff;
}

/* Results */
.SearchPage_resultsContainer__BNE9W {
  margin-top: 1.5rem;
}

.SearchPage_loadingContainer__W8AU5 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 0;
  color: #6b7280;
}

.SearchPage_resultsHeader__CPMzk {
  margin-bottom: 1.5rem;
}

.SearchPage_resultsTitle__jLEYS {
  font-size: 1.25rem;
  font-weight: 600;
  color: white;
  margin: 0;
}

.SearchPage_resultsGrid__qtvJ8 {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1.5rem;
}

.SearchPage_resultCard__ghoQ2 {
  background-color: #1a1a1a;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
}

.SearchPage_resultCard__ghoQ2:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
}

.SearchPage_resultImageContainer__3ExvT {
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
}

.SearchPage_resultImage__UAQJy {
  width: 100%;
  height: 100%;
 }

.SearchPage_contentTypeBadge__qaQZe {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  text-transform: capitalize;
}

.SearchPage_resultContent__d1lEd {
  padding: 2rem 1rem;
}

.SearchPage_resultTitle__gSppn {
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #fff;
}

.SearchPage_resultGenre__X4aXH {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0 0 0.5rem 0;
}

.SearchPage_resultDescription__8oGZo {
  font-size: 0.875rem;
  color: #90959b;
  margin: 0;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.SearchPage_noResults__T-Bg4 {
  text-align: center;
  padding: 3rem 0;
  color: #6b7280;
}

.SearchPage_loadMoreButton__GV9WM {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  color: #4b5563;
  font-size: 0.875rem;
  font-weight: 500;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  margin: 2rem auto 0;
  cursor: pointer;
  transition: all 0.2s;
}

.SearchPage_loadMoreButton__GV9WM:hover {
  background-color: #e5e7eb;
}

.SearchPage_loadMoreButton__GV9WM:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .SearchPage_resultsGrid__qtvJ8 {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  }
}

@media (max-width: 640px) {
  .SearchPage_resultsGrid__qtvJ8 {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .SearchPage_filtersContainer__29DSu {
    overflow-x: auto;
    padding-bottom: 0.5rem;
    flex-wrap: nowrap;
  }
  .SearchPage_searchPageContainer__L7f8g{
    padding: 6rem 0;
    max-width: 95%;
    margin: 0 auto;
  }
}
@media (max-width: 500px) {
  .SearchPage_resultImageContainer__3ExvT {
    height: auto;
   }
}`, "",{"version":3,"sources":["webpack://./src/common/UI/CSS/SearchPage.module.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,mBAAmB;;AAErB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oDAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,sBAAsB;EACtB,4BAA4B;EAC5B,yCAAyC;EACzC,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;CACb;;AAED;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,cAAc;IACd,cAAc;EAChB;AACF;AACA;EACE;IACE,YAAY;GACb;AACH","sourcesContent":["/* SearchPage.module.css */\n.searchPageContainer {\n  width: 100%;\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 12rem 0rem;\n  \n}\n\n.searchWrapper {\n  width: 100%;\n  position: relative;\n}\n\n.searchContainer {\n  width: 100%;\n  position: relative;\n  border-radius: 12px;\n  overflow: visible;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  transition: all 0.2s ease;\n}\n\n.searchContainer.focused {\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);\n}\n\n.searchInputWrapper {\n  display: flex;\n  align-items: center;\n  background-color: #DC2626;\n  padding: 0.75rem 1rem;\n  border-radius: 12px;\n}\n\n.searchIcon {\n  color: #fff;\n  margin-right: 0.75rem;\n}\n\n.searchInput {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 1rem;\n  background-color: transparent;\n  color: #fff;\n}\ninput::placeholder {\n  color: #fff;\n}\n\n.clearButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition-duration: 0.2s;\n}\n\n.clearButton:hover {\n  color: #000;\n}\n\n.loadingIcon {\n  color: #6b7280;\n  margin-right: 0.75rem;\n}\n\n.spinning {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Suggestions */\n.suggestionsContainer {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background-color: #000;\n  border-radius: 0 0 12px 12px;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\n  z-index: 10;\n  max-height: 400px;\n  overflow-y: auto;\n  border: 1px solid #000;\n  border-top: none;\n}\n\n.suggestionsHeader,\n.trendingHeader {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #fff;\n  margin: 0;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #fff;\n}\n\n.suggestionsList,\n.trendingList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  color: #fff;\n}\n\n.suggestionItem,\n.trendingItem {\n  padding: 0.75rem 1rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  transition: background-color 0.2s;\n}\n\n.suggestionItem:hover,\n.trendingItem:hover {\n  background-color: #f9fafb;\n  color: #000;\n}\n\n.contentTypeIcon {\n  margin-right: 0.5rem;\n  color: #6b7280;\n}\n\n/* Filters */\n.filtersContainer {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 1rem 0;\n  gap: 0.5rem;\n}\n\n.filterButton {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  border-radius: 100px;\n  border: none;\n  background-color: #000;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #fff;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.filterButton:hover {\n  background-color: rgba(255, 0, 0, 0.2);\n}\n\n.filterButton.active {\n  background-color: red;\n  color: #fff;\n  border-color: red;\n}\n\n.filterButton.active .contentTypeIcon {\n  color: #fff;\n}\n\n/* Results */\n.resultsContainer {\n  margin-top: 1.5rem;\n}\n\n.loadingContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem 0;\n  color: #6b7280;\n}\n\n.resultsHeader {\n  margin-bottom: 1.5rem;\n}\n\n.resultsTitle {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: white;\n  margin: 0;\n}\n\n.resultsGrid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 1.5rem;\n}\n\n.resultCard {\n  background-color: #1a1a1a;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  transition: transform 0.2s, box-shadow 0.2s;\n  cursor: pointer;\n}\n\n.resultCard:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);\n}\n\n.resultImageContainer {\n  position: relative;\n  width: 100%;\n  height: auto;\n  overflow: hidden;\n}\n\n.resultImage {\n  width: 100%;\n  height: 100%;\n }\n\n.contentTypeBadge {\n  position: absolute;\n  top: 0.75rem;\n  right: 0.75rem;\n  background-color: rgba(0, 0, 0, 0.7);\n  color: #fff;\n  font-size: 0.75rem;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  text-transform: capitalize;\n}\n\n.resultContent {\n  padding: 2rem 1rem;\n}\n\n.resultTitle {\n  font-size: 1rem;\n  font-weight: 600;\n  margin: 0 0 0.5rem 0;\n  color: #fff;\n}\n\n.resultGenre {\n  font-size: 0.875rem;\n  color: #6b7280;\n  margin: 0 0 0.5rem 0;\n}\n\n.resultDescription {\n  font-size: 0.875rem;\n  color: #90959b;\n  margin: 0;\n  line-height: 1.5;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.noResults {\n  text-align: center;\n  padding: 3rem 0;\n  color: #6b7280;\n}\n\n.loadMoreButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  background-color: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  color: #4b5563;\n  font-size: 0.875rem;\n  font-weight: 500;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  margin: 2rem auto 0;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.loadMoreButton:hover {\n  background-color: #e5e7eb;\n}\n\n.loadMoreButton:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n  .resultsGrid {\n    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  }\n}\n\n@media (max-width: 640px) {\n  .resultsGrid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  \n  .filtersContainer {\n    overflow-x: auto;\n    padding-bottom: 0.5rem;\n    flex-wrap: nowrap;\n  }\n  .searchPageContainer{\n    padding: 6rem 0;\n    max-width: 95%;\n    margin: 0 auto;\n  }\n}\n@media (max-width: 500px) {\n  .resultImageContainer {\n    height: auto;\n   }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchPageContainer": `SearchPage_searchPageContainer__L7f8g`,
	"searchWrapper": `SearchPage_searchWrapper__654NC`,
	"searchContainer": `SearchPage_searchContainer__C+ADr`,
	"focused": `SearchPage_focused__EJyn3`,
	"searchInputWrapper": `SearchPage_searchInputWrapper__GCIoN`,
	"searchIcon": `SearchPage_searchIcon__1ZkpL`,
	"searchInput": `SearchPage_searchInput__uGKnk`,
	"clearButton": `SearchPage_clearButton__jToKa`,
	"loadingIcon": `SearchPage_loadingIcon__9njCf`,
	"spinning": `SearchPage_spinning__tXvI9`,
	"spin": `SearchPage_spin__lbCzR`,
	"suggestionsContainer": `SearchPage_suggestionsContainer__J+E7o`,
	"suggestionsHeader": `SearchPage_suggestionsHeader__wy8jl`,
	"trendingHeader": `SearchPage_trendingHeader__ad-x6`,
	"suggestionsList": `SearchPage_suggestionsList__xPJIs`,
	"trendingList": `SearchPage_trendingList__jtUli`,
	"suggestionItem": `SearchPage_suggestionItem__vqpwm`,
	"trendingItem": `SearchPage_trendingItem__oKV8E`,
	"contentTypeIcon": `SearchPage_contentTypeIcon__lPX5e`,
	"filtersContainer": `SearchPage_filtersContainer__29DSu`,
	"filterButton": `SearchPage_filterButton__aFjrZ`,
	"active": `SearchPage_active__Et221`,
	"resultsContainer": `SearchPage_resultsContainer__BNE9W`,
	"loadingContainer": `SearchPage_loadingContainer__W8AU5`,
	"resultsHeader": `SearchPage_resultsHeader__CPMzk`,
	"resultsTitle": `SearchPage_resultsTitle__jLEYS`,
	"resultsGrid": `SearchPage_resultsGrid__qtvJ8`,
	"resultCard": `SearchPage_resultCard__ghoQ2`,
	"resultImageContainer": `SearchPage_resultImageContainer__3ExvT`,
	"resultImage": `SearchPage_resultImage__UAQJy`,
	"contentTypeBadge": `SearchPage_contentTypeBadge__qaQZe`,
	"resultContent": `SearchPage_resultContent__d1lEd`,
	"resultTitle": `SearchPage_resultTitle__gSppn`,
	"resultGenre": `SearchPage_resultGenre__X4aXH`,
	"resultDescription": `SearchPage_resultDescription__8oGZo`,
	"noResults": `SearchPage_noResults__T-Bg4`,
	"loadMoreButton": `SearchPage_loadMoreButton__GV9WM`
};
export default ___CSS_LOADER_EXPORT___;
